<template>
    <svg
        fill="none"
        height="19"
        viewBox="0 0 17 19"
        width="17"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1042_1263)">
            <path
                d="M16.231 4.00228H14.3079V2.37331C14.3079 2.14933 14.1348 1.96606 13.9232 1.96606H0.769391C0.557854 1.96606 0.384766 2.14933 0.384766 2.37331V15.405C0.384766 16.3009 1.07708 17.034 1.92323 17.034H15.0771C15.9232 17.034 16.6155 16.3009 16.6155 15.405V4.40953C16.6155 4.18555 16.4425 4.00228 16.231 4.00228Z"
                :fill="background" />
            <path
                d="M6.3847 6.44568H2.69238V10.5588H6.3847V6.44568Z"
                :fill="background" />
            <path
                d="M6.57684 14.1833H2.69224C2.47981 14.1833 2.30762 14.3656 2.30762 14.5905C2.30762 14.8155 2.47981 14.9978 2.69224 14.9978H6.57684C6.78928 14.9978 6.96147 14.8155 6.96147 14.5905C6.96147 14.3656 6.78928 14.1833 6.57684 14.1833Z"
                fill="currentColor" />
            <path
                d="M12.3845 14.1833H8.49986C8.28743 14.1833 8.11523 14.3656 8.11523 14.5905C8.11523 14.8155 8.28743 14.9978 8.49986 14.9978H12.3845C12.5969 14.9978 12.7691 14.8155 12.7691 14.5905C12.7691 14.3656 12.5969 14.1833 12.3845 14.1833Z"
                fill="currentColor" />
            <path
                d="M12.3845 4.00226H2.69224C2.47981 4.00226 2.30762 4.18458 2.30762 4.40951C2.30762 4.63444 2.47981 4.81676 2.69224 4.81676H12.3846C12.597 4.81676 12.7692 4.63444 12.7692 4.40951C12.7692 4.18458 12.5969 4.00226 12.3845 4.00226Z"
                fill="currentColor" />
            <path
                d="M12.3845 6.03845H8.49986C8.28743 6.03845 8.11523 6.22077 8.11523 6.4457C8.11523 6.67063 8.28743 6.85295 8.49986 6.85295H12.3845C12.5969 6.85295 12.7691 6.67063 12.7691 6.4457C12.7691 6.22077 12.5969 6.03845 12.3845 6.03845Z"
                fill="currentColor" />
            <path
                d="M12.3845 8.07465H8.49986C8.28743 8.07465 8.11523 8.25697 8.11523 8.4819C8.11523 8.70683 8.28743 8.88915 8.49986 8.88915H12.3845C12.5969 8.88915 12.7691 8.70683 12.7691 8.4819C12.7691 8.25697 12.5969 8.07465 12.3845 8.07465Z"
                fill="currentColor" />
            <path
                d="M12.3845 10.1109H8.49986C8.28743 10.1109 8.11523 10.2932 8.11523 10.5182C8.11523 10.7431 8.28743 10.9254 8.49986 10.9254H12.3845C12.5969 10.9254 12.7691 10.7431 12.7691 10.5182C12.7691 10.2932 12.5969 10.1109 12.3845 10.1109Z"
                fill="currentColor" />
            <path
                d="M12.3845 12.147H8.49986C8.28743 12.147 8.11523 12.3294 8.11523 12.5543C8.11523 12.7792 8.28743 12.9615 8.49986 12.9615H12.3845C12.5969 12.9615 12.7691 12.7792 12.7691 12.5543C12.7691 12.3294 12.5969 12.147 12.3845 12.147Z"
                fill="currentColor" />
            <path
                d="M6.57684 12.147H2.69224C2.47981 12.147 2.30762 12.3294 2.30762 12.5543C2.30762 12.7792 2.47981 12.9615 2.69224 12.9615H6.57684C6.78928 12.9615 6.96147 12.7792 6.96147 12.5543C6.96147 12.3294 6.78928 12.147 6.57684 12.147Z"
                fill="currentColor" />
            <path
                d="M6.57684 6.03845H2.69224C2.47981 6.03845 2.30762 6.22077 2.30762 6.4457V10.5588C2.30762 10.7837 2.47981 10.9661 2.69224 10.9661H6.57684C6.78928 10.9661 6.96147 10.7837 6.96147 10.5588V6.4457C6.96147 6.22081 6.78928 6.03845 6.57684 6.03845ZM6.19225 10.1516H3.07687V6.85295H6.19225V10.1516Z"
                fill="currentColor" />
            <path
                d="M16.2308 3.59502H15.0769V2.3733C15.0769 1.92418 14.7319 1.55884 14.3077 1.55884H0.769217C0.34508 1.55884 0 1.92422 0 2.3733V15.405C0 16.5277 0.862684 17.4412 1.92309 17.4412H15.0769C16.1373 17.4412 17 16.5278 17 15.405V4.40952C17 3.9604 16.6549 3.59502 16.2308 3.59502ZM16.2308 15.405C16.2308 16.0786 15.7132 16.6267 15.0769 16.6267H1.92309C1.28685 16.6267 0.76925 16.0786 0.76925 15.405V2.3733H14.3077V14.7941C14.3077 15.3555 14.7391 15.8122 15.2693 15.8122C15.4817 15.8122 15.6539 15.6299 15.6539 15.405C15.6539 15.18 15.4817 14.9977 15.2693 14.9977C15.1632 14.9977 15.0769 14.9064 15.0769 14.7941V4.40952H16.2308V15.405Z"
                fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clip0_1042_1263">
                <rect
                    :fill="background"
                    height="18"
                    transform="translate(0 0.5)"
                    width="17" />
            </clipPath>
        </defs>
    </svg>
</template>

<script setup lang="ts">

    const props = defineProps<{
        background?: string;
    }>();

    const background = computed(() => props.background || '#FFFFFF');

</script>

<style scoped></style>
